import { render, staticRenderFns } from "./SubTabs.vue?vue&type=template&id=7702494d&scoped=true&"
import script from "./SubTabs.vue?vue&type=script&lang=js&"
export * from "./SubTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7702494d",
  null
  
)

export default component.exports